/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Cms_DescriptionInputs */

const en_landing_features_cms_description = /** @type {(inputs: Landing_Features_Cms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories and posts with full CRUD, status management, and admin panel — build your blog or docs.`)
};

const zh_landing_features_cms_description = /** @type {(inputs: Landing_Features_Cms_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类和文章的完整 CRUD，支持状态管理和管理后台 — 快速搭建博客或文档。`)
};

/**
* | output |
* | --- |
* | "Categories and posts with full CRUD, status management, and admin panel — build your blog or docs." |
*
* @param {Landing_Features_Cms_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_cms_description = /** @type {((inputs?: Landing_Features_Cms_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Cms_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_cms_description(inputs)
	return zh_landing_features_cms_description(inputs)
});
export { landing_features_cms_description as "landing.features.cms.description" }